import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as integrationsActions from '../redux/actions/integrationsActions';

import ApiCallsView from './ApiCallsView';

const noDataFoundMessage = 'There are no API calls made.';

export class ApiCallsControllerController extends Component {
  constructor(props) {
    super(props);

    this.state = {
      period_start: '',
      period_end: '',
      interval_grouping: 'day',
      period_selected: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.getApiCallsSummary();
  }

  getApiCallsDetails = (period_start, period_end, interval_grouping) => {
    this.props.dispatch(integrationsActions.getApiCallsDetails({
      uid: this.props.uid,
      period_start,
      period_end,
      interval_grouping,
      periods: this.props.periods ? this.props.periods : [],
    }));
  };

  getApiCallsSummary = () => {
    this.props.dispatch(integrationsActions.getApiCallsSummary({
      uid: this.props.uid,
      usage: this.props.usage ? this.props.usage : [],
    }));
  };

  handleChange = (params) => {
    if (params) {
      params = JSON.parse(params);
      this.setState({
        period_start: params.period_start,
        period_end: params.period_end,
        period_selected: true,
      });
      this.getApiCallsDetails(params.period_start, params.period_end, this.state.interval_grouping);
    }
  };

  render() {
    return (
      <ApiCallsView
        {...this.props}
        noDataFoundMessage={noDataFoundMessage}
        period_start={this.state.period_start}
        period_end={this.state.period_end}
        interval_grouping={this.state.interval_grouping}
        period_selected={this.state.period_selected}
        handleChange={params => this.handleChange(params)}
      />
    );
  }
}

ApiCallsControllerController.defaultProps = {
  error: null,
};

ApiCallsControllerController.propTypes = {
  dispatch: PropTypes.func.isRequired,
  uid: PropTypes.string.isRequired,
  dataReady: PropTypes.bool.isRequired,
  usage: PropTypes.any.isRequired,
  periods: PropTypes.any.isRequired,
  status: PropTypes.string.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const integrationsState = state.get('integrations').toJS();
  return {
    dataReady: integrationsState.data_ready,
    usage: integrationsState.usage,
    periods: integrationsState.periods,
    status: integrationsState.status,
    error: integrationsState.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(ApiCallsControllerController);



/** WEBPACK FOOTER **
 ** ./src/Integrations/ApiCallsController.jsx
 **/